export default function inputValid() {
  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $scope.$watch($attrs.inputValid, (isValid) => {
        $ngModel.$setValidity('input-valid-directive', isValid);
      });
    },
  };
}
